<section class="home-faq" aria-labelledby="home-faq-title">
  <div class="home-faq__bubble home-faq__bubble--left" aria-hidden="true"></div>
  <div class="home-faq__bubble home-faq__bubble--right" aria-hidden="true"></div>

  <div class="home-faq__inner">
    <div class="home-faq__heading">
      <p class="home-faq__eyebrow">{{ eyebrow }}</p>
      <h2 id="home-faq-title" class="home-faq__title" [innerHTML]="titleSafe"></h2>
    </div>

    <div class="home-faq__list">
      @for (item of items; track item.orden; let i = $index) {
        <article
          class="home-faq__item"
          [class.home-faq__item--open]="openIndex === i"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="openIndex === i"
          [attr.aria-controls]="'home-faq-answer-' + i"
          (click)="toggleFaq(i)"
          (keydown.enter)="toggleFaq(i)"
          (keydown.space)="toggleFaq(i); $event.preventDefault()"
        >
          <div class="home-faq__summary">
            <span class="home-faq__question">{{ item.pregunta }}</span>
            <span class="home-faq__icon" aria-hidden="true"></span>
          </div>
          <div class="home-faq__answer-wrap" [id]="'home-faq-answer-' + i">
            <div class="home-faq__answer-inner">
              <p class="home-faq__answer">{{ item.respuesta }}</p>
            </div>
          </div>
        </article>
      }
    </div>
  </div>
</section>
